import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLockOpen } from '@fortawesome/pro-solid-svg-icons';
import { faBuildoutLogo } from 'helpers/custom_fontawesome_icons';
import { fetchTranslation } from '../../../../helpers/i18n';

export default function Complete({ loginOnly }) {
  return (
    <div>
      <div className="text-center mb-3 text-branding">
        <FontAwesomeIcon icon={loginOnly ? faBuildoutLogo : faLockOpen} size="2x" />
      </div>
      <h5 className="text-center mb-3">
        <strong>{loginOnly ? fetchTranslation('logging_in') : fetchTranslation('file_unlocked')}</strong>
      </h5>
      <p className="text-center">{fetchTranslation('hold_tight')}</p>
    </div>
  );
}

Complete.propTypes = {
  loginOnly: PropTypes.bool
};
